import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { AppConfigService } from '../config/app-config';
import { AuthService } from '../services';
import { SKIP_AUTH } from './http-context.tokens';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.context.get(SKIP_AUTH)) return next(request);
  const auth = inject(AuthService);
  const isApi = request.url.startsWith(inject(AppConfigService).config().apiUrl);
  const token = auth.getAuthToken();
  const outgoing = isApi
    ? request.clone({
        withCredentials: true,
        setHeaders: token ? { Authorization: `Bearer ${token}` } : {},
      })
    : request;
  return next(outgoing).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        error.status !== 401 ||
        !isApi ||
        !token ||
        request.url.toLowerCase().includes('/refreshsession')
      )
        return throwError(() => error);
      return from(auth.refreshSession()).pipe(
        switchMap((refreshed) => {
          const nextToken = auth.getAuthToken();
          return refreshed && nextToken
            ? next(
                request.clone({
                  withCredentials: true,
                  setHeaders: { Authorization: `Bearer ${nextToken}` },
                }),
              )
            : throwError(() => error);
        }),
      );
    }),
  );
};
